module.exports = __webpack_public_path__ + "img/what_are_gears_found.f51fac44.png";